import Paper from "@mui/material/Paper";
import useTranslation from "../../hooks/useTranslation";
import {
  Alert,
  Button,
  CircularProgress,
  FormControl,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import Box from "@mui/material/Box";
import React, { useEffect, useState } from "react";
import authStore from "../../stores/AuthStore";
import feedbackStore from "../../stores/FeedbackStore";
import { FeedbackSeverity } from "../../stores/FeedbackStore/types";
import { Link, useSearchParams } from "react-router-dom";

const ForgotPassword = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const hash = searchParams.get("hash") || "";
  const [loading, setLoading] = useState(true);
  const [newPassword, setNewPassword] = useState("");
  const [isNewPasswordValid, setIsNewPasswordValid] = useState(false);
  const [isNewPasswordComply, setIsNewPasswordComply] = useState(false);
  const [isSubmit, setIsSubmit] = useState(false);

  useEffect(() => {
    authStore
      .validateHash(hash)
      .then(() => setLoading(false))
      .catch(() => {
        feedbackStore.setShowFeedback(true, {
          message: "invalid-hash",
          severity: FeedbackSeverity.ERROR,
          position: "top",
        });
      });
  }, []);

  const handlePasswordChange = (value: string) => {
    setNewPassword(value);

    if (value.length > 5 && value.length < 51) {
      setIsNewPasswordValid(true);
    } else {
      setIsNewPasswordValid(false);
    }
  };

  const handleValidatePassword = (value: string) => {
    setIsNewPasswordComply(value === newPassword);
  };

  const handleSubmit = () => {
    setIsSubmit(true);
    authStore
      .resetPassword(hash, newPassword)
      .then(() => {
        feedbackStore.setShowFeedback(true, {
          message: "reset-successful",
          severity: FeedbackSeverity.SUCCESS,
          position: "top",
        });
      })
      .catch(() => {
        feedbackStore.setShowFeedback(true, {
          message: "error",
          severity: FeedbackSeverity.ERROR,
          position: "top",
        });
      });
  };

  return (
    <Paper
      sx={{
        width: "300px",
        margin: "60px auto",
        padding: "40px 30px 60px",
        boxSizing: "content-box",
      }}
    >
      {loading ? (
        <Stack justifyContent="center" alignItems="center">
          <CircularProgress />
        </Stack>
      ) : (
        <>
          <Typography variant="h4" sx={{ marginTop: 0, marginBottom: "40px" }}>
            {t("reset-password")}
          </Typography>
          <form>
            <Stack>
              <Box className="mb">
                <FormControl sx={{ width: "100%" }}>
                  <label className="mb">{t("new-password")}</label>
                  <TextField
                    onChange={(e) => handlePasswordChange(e.target.value)}
                  />
                  {!isNewPasswordValid && (
                    <Alert severity="error" className="mt">
                      {t("new-password-not-valid")}
                    </Alert>
                  )}
                </FormControl>
              </Box>

              <Box className="mb">
                <FormControl sx={{ width: "100%" }}>
                  <label className="mb">{t("new-password-validate")}</label>
                  <TextField
                    onChange={(e) => handleValidatePassword(e.target.value)}
                  />
                  {!isNewPasswordComply && newPassword && (
                    <Alert severity="error" className="mt">
                      {t("new-password-not-comply")}
                    </Alert>
                  )}
                </FormControl>
              </Box>

              <Button
                variant={"contained"}
                onClick={handleSubmit}
                disabled={!isNewPasswordComply || isSubmit}
              >
                {t("save")}
              </Button>
            </Stack>
          </form>
          {isSubmit && (
            <Stack
              justifyContent={"center"}
              alignItems={"center"}
              className={"pt"}
            >
              <Link to={"/login"}>
                <Button
                  variant={"outlined"}
                  onClick={() => feedbackStore.setShowFeedback(false)}
                >
                  <i className="fa fa-door-open" />
                  &nbsp;{t("login")}
                </Button>
              </Link>
            </Stack>
          )}
        </>
      )}
    </Paper>
  );
};

export default ForgotPassword;
